import { Suspense } from "react";
import styled from "styled-components";

import Counter from "./Counter";
import FilteredProducts from "./FilteredProducts";
import FilteringProvider from "./FilteringProvider";
import NameFilter from "./filters/NameFilter";
import ProductFilters from "./filters/ProductFilters";

export default function ProductFinder(props) {
    const { ProductComponent, limit, onSelect, persistentFiltersService } = props;
    return (
        <FilteringProvider
            limit={ limit }
            persistenceService={ persistentFiltersService }
        >
            <Styled>
                <span />
                <NameFilter />
                <ProductFilters />
                <Suspense>
                    <Counter />
                </Suspense>
                <Suspense>
                    <FilteredProducts
                        ProductComponent={ ProductComponent }
                        onSelect={ onSelect }
                    />
                </Suspense>
            </Styled>
        </FilteringProvider>
    );
}

const Styled = styled.div`
    box-sizing: border-box;
    display: grid;
    gap: 32px 64px;
    grid-template-columns: 20% 1fr;
    grid-template-rows: min-content min-content 1fr;

    & > form:nth-child(3) {
        grid-row: 2 / -1;
    }
`;
